import { render, staticRenderFns } from "./TotalEditColumns.vue?vue&type=template&id=46a52579"
import script from "./TotalEditColumns.vue?vue&type=script&lang=ts"
export * from "./TotalEditColumns.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46a52579')) {
      api.createRecord('46a52579', component.options)
    } else {
      api.reload('46a52579', component.options)
    }
    module.hot.accept("./TotalEditColumns.vue?vue&type=template&id=46a52579", function () {
      api.rerender('46a52579', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/view-editor/TotalEditColumns.vue"
export default component.exports